import { render } from "./AddCountry.vue?vue&type=template&id=0dcfedb3&scoped=true"
import script from "./AddCountry.vue?vue&type=script&lang=js"
export * from "./AddCountry.vue?vue&type=script&lang=js"

import "./AddCountry.vue?vue&type=style&index=0&id=0dcfedb3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0dcfedb3"

export default script